import { Component, OnInit } from '@angular/core';
import { MfaFacade } from './mfa.facade';
import { MfaLoginService } from './services/mfa-login.service';
import { MfaResetPasswordService } from './services/mfa-reset-password.service';

@Component({
    selector: 'ifs-register-mfa',
    templateUrl: './mfa.component.html',
    providers: [
        MfaFacade,
        MfaLoginService,
        MfaResetPasswordService
    ],
    standalone: false
})
export class MfaComponent implements OnInit {
  constructor(private facade: MfaFacade) {}

  public ngOnInit(): void {
    this.facade.initActions();
  }
}
